import { render, staticRenderFns } from "./stock-addition-lines.vue?vue&type=template&id=84c0e88a&scoped=true"
import script from "./stock-addition-lines.vue?vue&type=script&lang=js"
export * from "./stock-addition-lines.vue?vue&type=script&lang=js"
import style0 from "./stock-addition-lines.vue?vue&type=style&index=0&id=84c0e88a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c0e88a",
  null
  
)

export default component.exports